import OperationSaleAgentBottomSheet from '../bottomSheetLists/operationSaleAgentBottomSheet';
import sales_agent from '../../../../../assets/image/shop/sales_agent.png';

const AddSaleAgents = ({
  saleAgentsBottomSheet,
  setSaleAgentsBottomSheet,
  refetchGetSaleAgentList,
  assigner_store,
}: IAddSaleAgentsProps) => {
  return (
    <div>
      <div className="flex flex-col items-center justify-center h-full px-3">
        <img src={sales_agent} className="h-42 w-48" alt="logo" />
        <span className="font-bold my-6">ثبت عاملین فروش</span>
        <p className="text-gray-900 leading-8 tracking-wider font-Regular text-md mb-6 text-justify">
          با افزودن عامل فروش، شبکه فروش خود را ایجاد کنید، تا در هر ساعت از
          شبانه روز، مشتریان برند شما در هر نقطه از کشور به نزدیکترین فروشگاه
          عرضه کننده کالا یا خدمات شما دسترسی پیدا کنند.
        </p>
      </div>
      <OperationSaleAgentBottomSheet
        {...{
          saleAgentsBottomSheet,
          setSaleAgentsBottomSheet,
          refetchGetSaleAgentList,
          assigner_store,
        }}
      />
    </div>
  );
};

export default AddSaleAgents;
